import React from "react";

/**
 * Per-bubble error boundary. If a single message component throws while
 * rendering (e.g. an unexpected metadata shape), we show the fallback instead
 * of crashing the entire chat list. Requirement: unknown/malformed messages
 * must NEVER crash the app.
 */
class MessageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("WhatsApp message render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}

export default MessageErrorBoundary;
